// CompanyAvatar (task 11.5 / R31) — a small colored chip showing a company's initial(s).
//
// The color is a DETERMINISTIC hash of the companyId into a curated, brand-harmonized
// palette (indigo / violet / emerald + close neighbors) so every company gets a stable,
// recognizable color WITHOUT any storage and WITHOUT re-theming the app. Color is always
// paired with the initial/name (never color-only) for accessibility.
import React from "react";

// Curated palette — harmonized with the Boomerang accent (indigo/violet) + emerald.
// Each entry: [background, foreground]. Kept intentionally soft so chips sit calmly
// next to the existing UI rather than competing with the marketing brand.
const PALETTE = [
  ["#e0e7ff", "#4338ca"], // indigo
  ["#ede9fe", "#6d28d9"], // violet
  ["#d1fae5", "#047857"], // emerald
  ["#e0f2fe", "#0369a1"], // sky
  ["#fae8ff", "#a21caf"], // fuchsia
  ["#dbeafe", "#1d4ed8"], // blue
  ["#ccfbf1", "#0f766e"], // teal
  ["#e2e8f0", "#334155"], // slate — neutral tone
];

function hashString(str) {
  let h = 0;
  for (let i = 0; i < (str || "").length; i++) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0; // 32-bit
  }
  return Math.abs(h);
}

function initials(name) {
  const words = (name || "").trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
}

export function companyColor(companyId) {
  return PALETTE[hashString(companyId || "default_company") % PALETTE.length];
}

export default function CompanyAvatar({ companyId, name, size = 22, title }) {
  const [bg, fg] = companyColor(companyId);
  const dim = `${size}px`;
  return (
    <span
      title={title || name || companyId}
      aria-label={name || companyId}
      style={{
        display: "inline-flex", alignItems: "center", justifyContent: "center",
        width: dim, height: dim, minWidth: dim, borderRadius: "6px",
        background: bg, color: fg,
        fontSize: `${Math.round(size * 0.42)}px`, fontWeight: 800, letterSpacing: "0.2px",
        userSelect: "none",
      }}
    >
      {initials(name)}
    </span>
  );
}
